<form   #form="ngForm">

  <div class="modal-header">
    <h4 class="modal-title">Temporary Password</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.close(null)">
      <span aria-hidden="true">&times;</span>
    </button>

  </div>
  <div class="modal-body">
    <p class="font-weight-bold">Enter a password for this user. The password should be communicated to the user.</p>

    <div class="row">
      <div class="form-group col-sm-6 col-lg-4 input-required">
        <label for="password" class="font-weight-normal">Password</label>
        <input autocomplete="off" re-autofocus #passwordControl="ngModel" [(ngModel)]="password" id="password" name="password" class="form-control" type="text" placeholder="Password (required)"
                (input)="passwordChanged()"
                (paste)="onPaste($event)"
               [ngbPopover]="popContent" popoverTitle="Password Requirements" placement="right"  />
        <small *ngIf="passwordControl.touched && !passwordControl.valid" class="text-danger">Please enter new user’s temporary password with rules.</small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-6 col-lg-4 input-required">
        <label for="confirmPassword" class="font-weight-normal">Confirm Password</label>
        <input autocomplete="off" #confirmPasswordControl="ngModel"  [(ngModel)]="confirmPassword" id="confirmPassword" name="confirmPassword" class="form-control" type="text" placeholder="Confirm Password (required)" />
        <small class="text-danger" *ngIf="confirmPasswordControl.touched && !confirmPasswordControl.valid ">Passwords do not match.</small>
      </div>
    </div>

    <div class="row" *ngIf="deactivationDate" style="margin: 0px 5px 0px 5px;">
      <re-alert type="warning" [dismissible]="false">
        This will remove deactivation date {{ deactivationDate.toISOString().split('T')[0] }} for the user.
        Once reactivated, you can change the deactivation date for the user later.
      </re-alert>
    </div>


  </div>
  <div class="modal-footer">
    <button type="submit" [re-disable-when-clicked] class="btn btn-primary" (click)="activate()" [disabled]="!form.valid  ">Reset Password</button>
    <button type="button" class="btn btn-cancel" (click)="close()">Close</button>
  </div>
</form>

<ng-template #popContent>
  <re-password-requirements [password]="password"
                            [username]="userName"
                            [firstName]="firstName"
                            [lastName]="lastName"
                            [domain]="selectedDomain">
  </re-password-requirements>

</ng-template> 
